import React from 'react';
import './index.css';

export const UploadErrorMsg = ({ msg = "" }) => (
    <div className="divRow" style={{ marginTop: 10 }}>
        <div className="errorMsgIcon mt-1" />
        <label className="successErrorLabel">{msg}</label>
    </div>
);